import {IRootReducer} from 'core/redux/reducers';
import {IUserState} from 'modules/user/types';
import {AnyAction, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {HYDRATE} from 'next-redux-wrapper';

export const userModuleName = 'user';

const initialState: IUserState = {
    data: null,
    userData: null,
};

export const userSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            return payload[userModuleName];
        });
    },
    initialState,
    name: userModuleName,
    reducers: {
        actionSetUser(state: IUserState, {payload}: PayloadAction<IUserState['userData']>) {
            state.userData = payload;
        },
    },
});

export const {
    actions: {actionSetUser},
} = userSlice;

export const {reducer: userReducer} = userSlice;
